import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content-inner" }

import { computed, reactive, ref, watch } from 'vue';
import { Select, Modal, message, Popover } from 'ant-design-vue';
import { useVueI18n } from '@/hooks';
import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons-vue';
import { showDialog } from '@/views/bill/pay/common/server';
import { engageLabCore } from '@jg/qiankun-micro-tool';

export default /*@__PURE__*/_defineComponent({
  __name: 'notificationPopover',
  props: {
    text: {}
  },
  setup(__props: any) {

const locale = engageLabCore.locale.takeImmediately();

const { t } = useVueI18n();
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), {
    "overlay-class-name": "aws-order-upgraded-popover aws-order-popover",
    "overlay-style": { width: __props.text === 'refunded' ? '333px' : '386px' }
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ExclamationCircleFilled), { style: {"color":"#faad14"} }),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showDialog) && _unref(showDialog)(...args)))
        }, _toDisplayString(_ctx.$t('otp.notes2a')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["status-text", __props.text])
      }, _toDisplayString(_unref(t)(`aws.aswStatus.${__props.text}`)), 3),
      _createVNode(_unref(InfoCircleFilled), { style: {"color":"rgba(37, 48, 68, 0.52)","margin-left":"4px"} })
    ]),
    _: 3
  }, 8, ["overlay-style"]))
}
}

})